<template>
    <div class="d-flex filterArea">
        <div class="d-flex mb-0">
            <div class="filter position-relative ml-2">
                <button id="filter" :title="$ml.get('FILTER')" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-click px-2 dropdown-button btn-crm-secondary" style="height:40px; width:40px;" >
                    <i class="fa fa-filter font-m px-1" ></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right p-0 multiChoose dropMenu" aria-labelledby="filter">
                    <div class="p-2">
                        <div class="searchBorder d-flex align-items-center rounded">
                            <input type="text" class="new-input border-0" placeholder="Search" v-model="searchItem">
                            <i class="fas fa-search pr-2 pl-1 text-secondary"></i>
                        </div>
                    </div>
                    <div class="new-dropdown rounded-0 shadow-none">
                        <template v-for="(filter,index) in filters" :key="index"><li v-if="filter && filter.name && filter.name.toLowerCase().includes(searchItem.toLowerCase())" class="dropdown-item">
                            <div class="d-flex align-items-center justify-content-between">
                                <label>
                                    <input type="radio" name="filter" @click="getFilter(index)" :value="filter.value"> 
                                    <span class="label-text f-14">{{filter.name}}</span>
                                </label>
                                <div class="updateAndDeleteSection">
                                    <i class="fas fa-pen mr-2" data-toggle="modal" data-target="#updateFilterModal" style="color: #0B63CE;" @click="updateFilter(index)"></i>
                                    <i class="far fa-trash-alt" style="color: #DA1414;" @click="deleteFilter(index)"></i>
                                </div>
                            </div>
                        </li></template>
                    </div>
                    <div style="width: 250px;">
                        <div class="d-flex align-items-center p-2">
                            <button class="btn btn-sm bg-new-primary py-2 filterBtn" data-toggle="modal" data-target="#createFilterModal" @click="createFilterSection">{{$ml.get('CREATE_NEW_FILTER')}}</button>
                            <button class="btn btn-sm clearBtn py-2 filterBtn" @click="clearFilter()">{{$ml.get('CLEAR_FILTER')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Create New Filter Modal -->
        <div class="modal fade h-100" id="createFilterModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="createFilterModalLabel" aria-hidden="true">

            <div class="modal-dialog modal-lg" role="document" v-if="saveAndApplyChecker == false">
                <div class="modal-content h-100">
                    <div class="modal-header filterModalTitle py-3">
                        <h5 class="modal-title" id="createFilterModalLabel">{{$ml.get('CREATE_FILTER')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body filter-modal" style="min-height: 30vh;">

                        <p class="mt-2 mb-4">{{$ml.get('FILTER_MEETS_CRITERIA')}}</p>


                        <div class="row filter-row" v-for="(item, index) in items" :key="index">
                            
                            <!-- ***************** Fieldname Field ********************************* -->
                            <div class="col-md-4">
                                <select class="new-input mb-3 bg-white input-fieldName" v-model="item.description" @change="changeFieldName($event,item)">
                                    <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="filter in filterDataOne">{{filter.name}}</option>
                                </select>
                            </div>

                            <!-- ***************** Operator Field ********************************* -->
                            <div v-if="item.options==='name'|| item.options==='source'|| item.options==='text' || item.options==='customContact'|| item.options==='customUser'|| item.options==='customOrganization'" class="col-md-2 px-0">
                                <select class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)" >
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators1">{{option.name}}</option>
                                </select>
                            </div>
                            <div v-else-if="item.options==='date'||item.options==='rate'||item.options==='currency'||item.options==='product'||item.options==='status'||item.options==='list'||item.options==='multiChoose'||item.options==='singleChoose'||item.options==='customDates'" class="col-md-2 px-0">
                                <select class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)">
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators2">{{option.name}}</option> 
                                </select>
                            </div>
                            <div v-else-if="item.options==='value'" class="col-md-2 px15 px-0">
                                <select class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)">
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators3">{{option.name}}</option> 
                                </select>
                            </div>
                            <div v-else-if="item.options==='customCurrency'" class="col-md-2 px15 px-0">
                                <select class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)">
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators4">{{option.name}}</option> 
                                </select>
                            </div>
                            <div v-else class="col-md-2 px15 px-0">
                                <select class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)">
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators">{{option.name}}</option>
                                </select>
                            </div>

                            <!-- ***************** Input Fields ********************************* -->
                            <div class="col-md-5" v-if="item.type==='name'">
                                <input type="text" class="new-input bg-white mb-3 inputValue" v-model="item.value" v-on:keyup="changeValue($event,item)">                               
                            </div>
                            <div v-else-if="item.type==='product'" class="col-md-5">
                                <input type="text" v-model="wordProduct" v-on:keyup="quickFilter($event,'one','product')" class="new-input bg-white"/>
                                <ul class="new-dropdown border-0 p-0 autocomplete-results" v-show='quickItemsOne.length>0'>
                                    <li class="autocomplete-result" v-for='(result, i) in quickItemsOne' :key="i" @click="setResult(result,'product','one',item)">{{result.name}}</li>
                                    <li class="autocomplete-result" v-if="quickItemsOne.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                                </ul>
                            </div>
                            <div v-else-if="item.type==='organization'" class="col-md-5">
                                <input type="text" v-model="wordOrganization" v-on:keyup="quickFilter($event,'one','organization')" class="new-input"/>
                                <ul class="new-dropdown border-0 p-0 autocomplete-results" v-show='quickItemsOne.length>0'>
                                    <li class="autocomplete-result" v-for='(result, i) in quickItemsOne' :key="i" @click="setResult(result,'organization','one',item)">{{result.name}}</li>
                                    <li class="autocomplete-result" v-if="quickItemsOne.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                                </ul>
                            </div>
                            <div v-else-if="item.type==='deal'" class="col-md-5">
                                <input type="text" v-model="wordDeal" v-on:keyup="quickFilter($event,'two','deal')" class="new-input"/>
                                <ul class="new-dropdown border-0 p-0 autocomplete-results" v-show='quickItemsTwo.length>0'>
                                    <li class="autocomplete-result" v-for='(result, i) in quickItemsTwo' :key="i" @click="setResult(result,'deal','two',item)">{{result.title}}</li>
                                    <li class="autocomplete-result" v-if="quickItemsTwo.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                                </ul>
                            </div>
                            <div v-else-if="item.type==='owner'" class="col-md-5 ">
                                <div class="last">
                                    <div class="btn-group">
                                        <button type="button" class="searchBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{selectListTextTwo}}
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0">
                                            <div class="search"><input type="text" class="new-input" v-model="userSearch"></div>
                                            <ul class="new-dropdown border-radius-0 p-0">
                                                <template v-for="user in usersForFilter" :key="user._id ? user._id.$oid : user.name">
                                                <li class="p-0" v-if="user.x">
                                                    <label class="w-100 custom-checkbox">
                                                        <input type="radio" name="filterUser" @change="changeUsers($event,user.name+' '+user.surName,'',item)" :value="user['_id']['$oid']"> 
                                                        <span class="label-text f-14">{{user.name}} {{user.surName}}</span>
                                                    </label>
                                                </li>
                                                </template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.type==='assignor'" class="col-md-5 ">
                                <div class="last">
                                    <div class="btn-group">
                                        <button type="button" class="searchBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{selectListTextTwo}}
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0">
                                            <div class="search"><input type="text" class="new-input" v-model="userSearch"></div>
                                            <ul class="new-dropdown border-radius-0 p-0">
                                                <template v-for="user in usersForFilter" :key="user._id ? user._id.$oid : user.name">
                                                <li class="p-0" v-if="user.x">
                                                    <label class="w-100 custom-checkbox">
                                                        <input type="radio" name="filterUser" @change="changeUsers($event,user.name+' '+user.surName,'',item)" :value="user['_id']['$oid']"> 
                                                        <span class="label-text f-14">{{user.name}} {{user.surName}}</span>
                                                    </label>
                                                </li>
                                                </template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.type==='assignedTo'" class="col-md-5 ">
                                <div class="last">
                                    <div class="btn-group">
                                        <button type="button" class="searchBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{selectListTextThree}}
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0">
                                            <div class="search"><input type="text" class="new-input" v-model="userSearch"></div>
                                            <ul class="new-dropdown border-radius-0 p-0">
                                                <template v-for="user in usersForFilter" :key="user._id ? user._id.$oid : user.name">
                                                <li class="p-0" v-if="user.x">
                                                    <label class="w-100 custom-checkbox">
                                                        <input type="radio" name="filterUser" @change="changeUsers($event,user.name+' '+user.surName,'assignedTo',item)" :value="user['_id']['$oid']"> 
                                                        <span class="label-text f-14">{{user.name}} {{user.surName}}</span>
                                                    </label>
                                                </li>
                                                </template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='date'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='expectedDate'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordExpectedDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='closedDate'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordClosedDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='doneDate'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordDoneDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='dueDate'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordDueDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='createdAt'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordCreatedDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='source'">
                                <select class="new-input bg-white mb-3" v-model="item.value" @change="changeValue($event,item)">
                                    <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('ADVERTISING')">{{$ml.get('ADVERTISING')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('PHONE_CALL')">{{$ml.get('PHONE_CALL')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('EMPLOYEE_ORUENTATION')">{{$ml.get('EMPLOYEE_ORUENTATION')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('EXTERNAL_ORUENTATION')">{{$ml.get('EXTERNAL_ORUENTATION')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('ONLINE_STORE')">{{$ml.get('ONLINE_STORE')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('BUSINES_PARTNER')">{{$ml.get('BUSINES_PARTNER')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('PUBLIC_RELATIONS')">{{$ml.get('PUBLIC_RELATIONS')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('SEMINAR')">{{$ml.get('SEMINAR')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('FAIR')">{{$ml.get('FAIR')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="Web">Web</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('EMAILING')">{{$ml.get('EMAILING')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('SOCIAL_MEDIA')">{{$ml.get('SOCIAL_MEDIA')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('AFFILIATE_PROGRAMS')">{{$ml.get('AFFILIATE_PROGRAMS')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('SEO')">{{$ml.get('SEO')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('PAID_SEARCH')">{{$ml.get('PAID_SEARCH')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('ONLINE_ADVERTISING')">{{$ml.get('ONLINE_ADVERTISING')}}</option>
                                </select>
                            </div>
                            
                            <div class="col-md-5" v-else-if="item.type==='currency'">
                                <select class="new-input bg-white mb-3" v-model="item.value" @change="changeValue($event,item)">
                                    <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="1">TL</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="2">USD</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="3">EUR</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="4">AUD</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="5">DKK</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="6">GBP</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="7">CHF</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="8">SEK</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="9">CAD</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="10">KWD</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="11">NOK</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="12">SAR</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="13">JPY</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="14">BGN</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="15">RON</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="16">RUB</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="17">IRR</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="18">CNY</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="19">PKR</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="20">QAR</option>
                                </select>
                            </div>

                            <div class="col-md-5" v-else-if="item.type==='rate'">
                                <select class="new-select bg-white" v-model="item.value" @change="changeValue($event,item)">
                                    <option class="f-14 font-family-regular font-weight-normal" value="" disabled selected>{{$ml.get('SELECT')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="1">{{$ml.get('NORMAL')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="2">{{$ml.get('PRIORITY')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="3">{{$ml.get('URGENT')}}</option>
                                </select>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='status'">
                                <div v-if="pageIs=='activity'">
                                    <select class="new-select bg-white" v-model="wordOne" @change="changeValue($event,item,'status')">
                                        <option v-for="option in statusOptions">{{option.label}}</option>
                                    </select>
                                </div>
                                <div v-else>                              
                                    <select class="new-select bg-white" v-model="statusValue" @change="changeValue($event,item,'status')">
                                        <option v-for="option in statusOptionsForOrg">{{option.label}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='dealStatus'">
                                    <select class="new-select bg-white" v-model="wordOne" @change="changeValue($event,item,'status')">
                                        <option v-for="option in dealsStatusOptions">{{option.label}}</option>
                                    </select>
                                </div>
                            <div v-else-if="item.type==='companyType'" class="col-md-5" >
                                <select class="new-select bg-white" v-model="isCandidate" @change="changeValue($event,item,'isType')">
                                    <option v-for="option in isCandidateOptions">{{option.label}}</option>
                                </select>
                            </div>
                            <div v-else-if="item.type==='contacts'" class="col-md-5">
                                <input type="text" v-model="wordContact" v-on:keyup="quickFilter($event,'one','contact')" class="new-input bg-white mb-3"/>
                                <ul class="new-dropdown border-0 p-0 autocomplete-results" v-show='quickItemsOne.length>0'>
                                    <li class="autocomplete-result" v-for='(result, i) in quickItemsOne' :key="i" @click="setResult(result,'contact','one',item)">{{result.n}} {{result.sn}}</li>
                                    <li class="autocomplete-result" v-if="quickItemsOne.length<1">{{$ml.get('NOT_FIND')}}!!</li>
                                </ul>
                            </div>
                            <div v-else-if="item.type==='list'" class="ml-1 mr-3">
                                <div class="d-flex ml-2" v-if="isUsersList&&(($can('can_see_other_users_deals')&&(pageIs=='deal'||pageIs=='opportunities'))||($can('can_see_other_users_activities')&&pageIs=='activity'))">
                                    <div class="last">
                                        <div class="btn-group">
                                            <button type="button" class="searchBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{selectListText}}
                                            <i class="fa fa-angle-down pull-right ml-2"></i>
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0">
                                                
                                                <div class="search"><input type="text" class="new-input" v-model="userSearch"></div>
                                                <ul class="new-dropdown border-radius-0 p-0">
                                                    <li class="p-0" v-if="pageIs=='activity'">
                                                        <label class="w-100 custom-checkbox" v-if="user['_id']!=undefined">
                                                            <input type="radio" name="filterUser" :value="user['_id']['$oid']" @change="changeUsers($event,$ml.get('MY_ACTIVITIES'),'assignTo',item)"> 
                                                            <span class="label-text f-14">{{$ml.get("MY_ACTIVITIES")}}</span>
                                                        </label>
                                                    </li>
                                                    <li class="p-0" v-if="pageIs=='activity'">
                                                        <label class="w-100 custom-checkbox" v-if="user['_id']!=undefined">
                                                            <input type="radio" name="filterUser" :value="user['_id']['$oid']" @change="changeUsers($event,$ml.get('ACTIVTY_I_ASSIGNED'),'',item)"> 
                                                            <span class="label-text f-14">{{$ml.get("ACTIVTY_I_ASSIGNED")}}</span>
                                                        </label>
                                                    </li>
                                                    <li class="p-0">
                                                        <label class="w-100 custom-checkbox">
                                                            <input type="radio" name="filterUser" value="all" checked @change="changeUsers($event,$ml.get('ALL_USERS'),'',item)"> 
                                                            <span class="label-text f-14">{{$ml.get('ALL_USERS')}}</span>
                                                        </label>
                                                    </li>
                                                    <li v-if="usersForFilter.length==0">{{$ml.get('NO_USER_FOUND')}}</li>
                                                    <li class="p-0" v-for="user in activeUsersForFilter" :key="user._id && user._id.$oid">
                                                        <label class="w-100 custom-checkbox">
                                                            <input type="radio" name="filterUser" @change="changeUsers($event,user.name+' '+user.surName,'',item)" :value="user['_id']['$oid']"> 
                                                            <span class="label-text f-14">{{user.name}} {{user.surName}}</span>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                            <div v-else-if="item.type==='customContact'" class="col-md-5">
                                <input type="text" v-model="wordCustomContact" v-on:keyup="quickFilter($event,'two','contact')" class="new-input"/>
                                <ul class="new-dropdown border-0 p-0 autocomplete-results" v-show='quickItemsTwo.length>0'>
                                    <li class="autocomplete-result" v-for='(result, i) in quickItemsTwo' :key="i" @click="setResult(result,'contact','two',item)">{{result.n}} {{result.sn}}</li>
                                    <li class="autocomplete-result" v-if="quickItemsTwo.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                                </ul>
                            </div>
                            <div v-else-if="item.type==='singleChoose'" class="col-md-5">
                                <template v-for="(i, index) in customFields" :key="index">
                                <select v-model="item.value" v-if="i.field_type===6 && item.field_type===i.field_type && item.title==i._id.$oid" @change="changeValue($event,item,'customField')" class="new-select bg-white">
                                    <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" v-for="(o, optIndex) in i.options" :key="optIndex" :value="o.id">{{o.label}}</option>
                                </select>
                                </template>
                            </div>
                            <div v-else-if="item.type==='customOrganization'" class="col-md-5">
                                <input type="text" v-model="wordCustomOrganization" v-on:keyup="quickFilter($event,'two','organization')" class="new-input"/>
                                <ul class="new-dropdown border-0 p-0 autocomplete-results" v-show='quickItemsTwo.length>0'>
                                    <li class="autocomplete-result" v-for='(result, i) in quickItemsTwo' :key="i" @click="setResult(result,'organization','two',item)">{{result.name}}</li>
                                    <li class="autocomplete-result" v-if="quickItemsTwo.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                                </ul>
                            </div>
                            <div v-else-if="item.type==='customUser'" class="col-md-5 ">
                                <div class="last">
                                    <div class="btn-group">
                                        <button type="button" class="searchBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{selectListTextTwo}}
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0">
                                            <input type="text" v-model="wordTwo" class="new-input"/>
                                            <ul class="new-dropdown border-radius-0 p-0">
                                                <li class="p-0" v-for="user in usersForFilter">
                                                    <label class="w-100 custom-checkbox">
                                                        <input type="radio" name="filterUser" @change="changeUsers($event,user.name+' '+user.surName,'',item)" :value="user['_id']['$oid']"> 
                                                        <span class="label-text f-14">{{user.name}} {{user.surName}}</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.type==='multiChoose'" class="col-md-5">
                                <template v-for="(i, index) in customFields" :key="index">
                                <select v-model="item.value" v-if="i.field_type===7 && item.field_type===i.field_type && item.title==i._id.$oid" class="new-select bg-white" @change="changeValue($event,item,'customField')">
                                    <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" v-for="(o, optIndex) in i.options" :key="optIndex" :value="o.id">{{o.label}}</option>
                                </select>
                                </template>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='customDates'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else>
                                <input type="text" v-model="item.value" class="new-input mb-3 bg-white inputValue" v-on:keyup="changeValue($event,item)">                               
                            </div>


                            <div class="col-md-1 px15 pb12 pl-1 " v-if="items.length >= 1">
                                <a class="btn btn-danger trash-icon" v-on:click="removeItem(index)">
                                    <i class="far fa-trash-alt text-white"></i>
                                </a>
                            </div>
                            
                        </div>


                        <button class="btn bg-new-primary btn-lg mt-3" @click="addCondition()">
                            <i class="fas fa-plus mr-1"></i>
                            {{$ml.get('ADD_CRITERIA')}}
                        </button>

                    </div>


                    <div class="modal-footer">
                        <button type="button" class="btn bg-transparent" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn button-outline bg-new-primary" onclick="$('#createFilterModal').modal('hide');" aria-label="Close" @click="applyFilter()">{{$ml.get('APPLY')}}</button>
                        <!-- <button type="button" class="btn button-outline bg-new-primary" @click="applyFilter()">{{$ml.get('APPLY')}}</button> -->
                        <button type="button" class="btn bg-new-primary" @click="proceedTosaveAndApply()">{{$ml.get('SAVE_AND_APPLY')}}</button>
                    </div>
                </div>
            </div>

            <div class="modal-dialog modal-md px-2" role="document" v-else>
                <div class="modal-content h-100" v-if="sameFilterTitle == false">
                    <div class="modal-header filterModalTitle py-3">
                        <h5 class="modal-title" id="createFilterModalLabel">
                            <i class="fas fa-exclamation-circle mr-1"></i>
                            {{$ml.get('SAVE_FILTER')}}
                        </h5>
                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body filter-modal" style="min-height: 20vh;">
                        <div v-if="filterType === 'deals'">
                            <label class="new-label font-family-bold">{{$ml.get('DEALS_NAME')}}*</label>
                            <input type="text" v-model="saveFieldName" class="new-input mb-2 w-100" />
                        </div>
                        <div v-if="filterType === 'activities'">
                            <label class="new-label font-family-bold">{{$ml.get('ACTIVITY_NAME')}}*</label>
                            <input type="text" v-model="saveFieldName" class="new-input mb-2 w-100" />
                        </div>
                        <div v-if="filterType === 'organizations'">
                            <label class="new-label font-family-bold">{{$ml.get('ORGANIZATION_NAME')}}*</label>
                            <input type="text" v-model="saveFieldName" class="new-input mb-2 w-100" />
                        </div>
                        <div v-if="filterType === 'contacts'">
                            <label class="new-label font-family-bold">{{$ml.get('CONTACT_NAME_V2')}}*</label>
                            <input type="text" v-model="saveFieldName" class="new-input mb-2 w-100" />
                        </div>
                        <div v-if="filterType === 'products'">
                            <label class="new-label font-family-bold">{{$ml.get('PRODUCT_NAME')}}*</label>
                            <input type="text" v-model="saveFieldName" class="new-input mb-2 w-100" />
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn bg-transparent" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn bg-new-primary" @click="saveAndApply()">{{$ml.get('SAVE_AND_APPLY')}}</button>
                        <!-- <button type="button" class="btn bg-new-primary" @click="saveAndApply()">{{$ml.get('SAVE_AND_APPLY')}}</button> -->
                    </div>
                </div>
                <div class="modal-content h-100" v-else-if="sameFilterTitle == true">
                    <div class="modal-header filterModalTitle py-3">
                        <h5 class="modal-title" id="createFilterModalLabel">
                            <i class="fas fa-exclamation-circle mr-1"></i>
                            Tekrarlanan Kayıt İsmi
                        </h5>
                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body filter-modal d-flex justify-content-center align-items-center" style="min-height: 10vh;">
                        <p><strong>{{ saveFieldName }}</strong> zaten var.Yeni kaydı nasıl oluşturmak istiyorsunuz?</p>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn bg-transparent" data-dismiss="modal" aria-label="Close">{{$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn button-outline bg-new-primary" @click="overwrite">Üzerine Yaz</button>
                        <button type="button" class="btn bg-new-primary" @click="saveAs">Farklı Kaydet</button>
                    </div>
                </div>
            </div>

        </div>



        <!-- //////////////////////////// Update Filter Modal ///////////////////////////////////// -->
        <div class="modal fade h-100" id="updateFilterModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="updateFilterModalLabel" aria-hidden="true">

            <div class="modal-dialog modal-lg" role="document" v-if="saveAndApplyChecker == false">
                <div class="modal-content h-100">
                    <div class="modal-header filterModalTitle py-3">
                        <h5 class="modal-title" id="updateFilterModalLabel">{{$ml.get('EDIT_FILTER')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body filter-modal" style="min-height: 30vh;">


                        <div v-if="isChangeFilterName==false" class="filterName">
                            {{saveFieldName}}
                            <i class="fas fa-pen ml-3" style="font-size:18px; color:#858C94;" @click="isChangeFilterName=true"></i>
                        </div>
                        <div v-if="isChangeFilterName==true" class="filterName">
                            <input type="text" class="filterNameInput" v-model="saveFieldName">
                            <i class="fa fa-check ml-3" style="font-size:20px; color:#27AE60;" @click="changeFilterName()"></i>
                        </div>

                        <div class="row d-flex align-items-center my-4">
                            <p class="col-md-9 pr-0">{{$ml.get('MODIFY_CRITERIA_OF_SELECTED_FILTER')}}</p>
                            <button class="btn bg-new-primary btn-lg col-md-2 ml-5" @click="addUpdateCondition()">
                                <i class="fas fa-plus mr-1"></i>
                                {{$ml.get('ADD_CRITERIA')}}
                            </button>
                        </div>



                        <div class="row filter-row" v-for="(item, index) in updateItems" :key="index">
                            <div class="col-md-4">
                                <select class="new-input mb-3 bg-white input-fieldName" @change="changeFieldName($event,item)">
                                    <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="filter in filterDataOne" :value="filter.value" :key="filter.value" :selected="item.title===filter.value">{{filter.name}}</option>
                                    <option v-for="i in customFields" :value="i._id.$oid" :key="i._id.$oid" :selected="item.title===i._id.$oid">{{i.name}}</option>
                                </select>
                            </div>


                            <div v-if="item.options==='name'|| item.options==='source'|| item.options==='text' || item.options==='customContact'|| item.options==='customUser'|| item.options==='customOrganization'" class="col-md-2 px-0">
                                <select v-if="item.operator!=''" class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)" >
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators1" :value="option.value" :key="option.value" :selected="item.operator===option.value">{{option.name}}</option>
                                </select>

                                <select v-else class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)" >
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators1">{{option.name}}</option>
                                </select>
                            </div>
                            
                            <div v-else-if="item.options==='date'||item.options==='rate'||item.options==='currency'||item.options==='product'||item.options==='status'||item.options==='list'||item.options==='multiChoose'||item.options==='singleChoose'||item.options==='customDates'" class="col-md-2 px-0">
                                <select v-if="item.operator!=''" class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)">
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators2" :value="option.value" :key="option.value" :selected="item.operator===option.value">{{option.name}}</option> 
                                </select>
                                <select v-else class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)">
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators2">{{option.name}}</option> 
                                </select>
                            </div>
                            <div v-else-if="item.options==='value'" class="col-md-2 px-0">
                                <select v-if="item.operator!=''" class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)">
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators3" :value="option.value" :key="option.value" :selected="item.operator===option.value">{{option.name}}</option> 
                                </select>
                                <select v-else class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)">
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators3">{{option.name}}</option> 
                                </select>
                            </div>
                            <div v-else-if="item.options==='customCurrency'" class="col-md-2 px-0">
                                <select v-if="item.operator!=''" class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)">
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators4" :value="option.value" :key="option.value" :selected="item.operator===option.value">{{option.name}}</option> 
                                </select>
                                <select v-else class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)">
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators4">{{option.name}}</option> 
                                </select>
                            </div>
                            <div v-else class="col-md-2 px-0">
                                <select v-if="item.operator!=''" class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)">
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators" :value="option.value" :key="option.value" :selected="item.operator===option.value">{{option.name}}</option>
                                </select>
                                <select v-else class="new-input mb-3 bg-white operator" @change="changeOperator($event,item)">
                                    <option value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="option in operators">{{option.name}}</option>
                                </select>
                            </div>

                            

                            <div class="col-md-5" v-if="item.type==='name'">
                                <input type="text" class="new-input bg-white mb-3 inputValue" v-model="item.value" v-on:keyup="changeValue($event,item)">                               
                            </div>
                            <div v-else-if="item.type==='product'" class="col-md-5">
                                <input type="text" v-model="wordProduct" v-on:keyup="quickFilter($event,'one','product')" class="new-input bg-white"/>
                                <ul class="new-dropdown border-0 p-0 autocomplete-results" v-show='quickItemsOne.length>0'>
                                    <li class="autocomplete-result" v-for='(result, i) in quickItemsOne' :key="i" @click="setResult(result,'product','one',item)">{{result.name}}</li>
                                    <li class="autocomplete-result" v-if="quickItemsOne.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                                </ul>
                            </div>
                            <div v-else-if="item.type==='organization'" class="col-md-5">
                                <input type="text" v-model="wordOrganization" v-on:keyup="quickFilter($event,'one','organization')" class="new-input"/>
                                <ul class="new-dropdown border-0 p-0 autocomplete-results" v-show='quickItemsOne.length>0'>
                                    <li class="autocomplete-result" v-for='(result, i) in quickItemsOne' :key="i" @click="setResult(result,'organization','one',item)">{{result.name}}</li>
                                    <li class="autocomplete-result" v-if="quickItemsOne.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                                </ul>
                            </div>
                            <div v-else-if="item.type==='deal'" class="col-md-5">
                                <input type="text" v-model="wordDeal" v-on:keyup="quickFilter($event,'two','deal')" class="new-input"/>
                                <ul class="new-dropdown border-0 p-0 autocomplete-results" v-show='quickItemsTwo.length>0'>
                                    <li class="autocomplete-result" v-for='(result, i) in quickItemsTwo' :key="i" @click="setResult(result,'deal','two',item)">{{result.title}}</li>
                                    <li class="autocomplete-result" v-if="quickItemsTwo.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                                </ul>
                            </div>
                            <div v-else-if="item.type==='owner'" class="col-md-5 ">
                                <div class="last">
                                    <div class="btn-group">
                                        <button type="button" class="searchBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{selectListTextTwo}}
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0">
                                            <div class="search"><input type="text" class="new-input" v-model="userSearch"></div>
                                            <ul class="new-dropdown border-radius-0 p-0">
                                                <li class="p-0" v-for="user in activeUsersForFilter" :key="user._id && user._id.$oid">
                                                    <label class="w-100 custom-checkbox">
                                                        <input type="radio" name="filterUser" @change="changeUsers($event,user.name+' '+user.surName,'',item)" :value="user['_id']['$oid']"> 
                                                        <span class="label-text f-14">{{user.name}} {{user.surName}}</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.type==='assignor'" class="col-md-5 ">
                                <div class="last">
                                    <div class="btn-group">
                                        <button type="button" class="searchBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{selectListTextTwo}}
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0">
                                            <div class="search"><input type="text" class="new-input" v-model="userSearch"></div>
                                            <ul class="new-dropdown border-radius-0 p-0">
                                                <li class="p-0" v-for="user in activeUsersForFilter" :key="user._id && user._id.$oid">
                                                    <label class="w-100 custom-checkbox">
                                                        <input type="radio" name="filterUser" @change="changeUsers($event,user.name+' '+user.surName,'',item)" :value="user['_id']['$oid']"> 
                                                        <span class="label-text f-14">{{user.name}} {{user.surName}}</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.type==='assignedTo'" class="col-md-5 ">
                                <div class="last">
                                    <div class="btn-group">
                                        <button type="button" class="searchBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{selectListTextThree}}
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0">
                                            <div class="search"><input type="text" class="new-input" v-model="userSearch"></div>
                                            <ul class="new-dropdown border-radius-0 p-0">
                                                <li class="p-0" v-for="user in activeUsersForFilter" :key="user._id && user._id.$oid">
                                                    <label class="w-100 custom-checkbox">
                                                        <input type="radio" name="filterUser" @change="changeUsers($event,user.name+' '+user.surName,'assignedTo',item)" :value="user['_id']['$oid']"> 
                                                        <span class="label-text f-14">{{user.name}} {{user.surName}}</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='date'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='expectedDate'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordExpectedDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='closedDate'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordClosedDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='doneDate'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordDoneDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='dueDate'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordDueDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='createdAt'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordCreatedDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='source'">
                                <select class="new-input bg-white mb-3" v-model="item.value" @change="changeValue($event,item)">
                                    <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('ADVERTISING')">{{$ml.get('ADVERTISING')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('PHONE_CALL')">{{$ml.get('PHONE_CALL')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('EMPLOYEE_ORUENTATION')">{{$ml.get('EMPLOYEE_ORUENTATION')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('EXTERNAL_ORUENTATION')">{{$ml.get('EXTERNAL_ORUENTATION')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('ONLINE_STORE')">{{$ml.get('ONLINE_STORE')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('BUSINES_PARTNER')">{{$ml.get('BUSINES_PARTNER')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('PUBLIC_RELATIONS')">{{$ml.get('PUBLIC_RELATIONS')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('SEMINAR')">{{$ml.get('SEMINAR')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('FAIR')">{{$ml.get('FAIR')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="Web">Web</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('EMAILING')">{{$ml.get('EMAILING')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('SOCIAL_MEDIA')">{{$ml.get('SOCIAL_MEDIA')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('AFFILIATE_PROGRAMS')">{{$ml.get('AFFILIATE_PROGRAMS')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('SEO')">{{$ml.get('SEO')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('PAID_SEARCH')">{{$ml.get('PAID_SEARCH')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="$ml.get('ONLINE_ADVERTISING')">{{$ml.get('ONLINE_ADVERTISING')}}</option>
                                </select>
                            </div>
                            
                            <div class="col-md-5" v-else-if="item.type==='currency'">
                                <select class="new-input bg-white mb-3" v-model="item.value" @change="changeValue($event,item)">
                                    <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="1">TL</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="2">USD</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="3">EUR</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="4">AUD</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="5">DKK</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="6">GBP</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="7">CHF</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="8">SEK</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="9">CAD</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="10">KWD</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="11">NOK</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="12">SAR</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="13">JPY</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="14">BGN</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="15">RON</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="16">RUB</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="17">IRR</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="18">CNY</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="19">PKR</option>
                                    <option class="f-14 font-family-regular font-weight-normal" value="20">QAR</option>
                                </select>
                            </div>

                            <div class="col-md-5" v-else-if="item.type==='rate'">
                                <select class="new-select bg-white" v-model="item.value" @change="changeValue($event,item)">
                                    <option class="f-14 font-family-regular font-weight-normal" value="" disabled selected>{{$ml.get('SELECT')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="1">{{$ml.get('NORMAL')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="2">{{$ml.get('PRIORITY')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" :value="3">{{$ml.get('URGENT')}}</option>
                                </select>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='status'">
                                <div v-if="pageIs=='activity'">
                                    <select v-if="item.value!=''" class="new-select bg-white" v-model="item.value" @change="changeValue($event,item,'status')">
                                        <option v-for="option in statusOptions" :value="option.value" :key="option.value" :selected="item.value===option.value">{{option.label}}</option>
                                    </select>
                                    <select v-else class="new-select bg-white" v-model="wordOne" @change="changeValue($event,item,'status')">
                                        <option v-for="option in statusOptions">{{option.label}}</option>
                                    </select>
                                </div>
                                <div v-else>                              
                                    <select v-if="item.value!=''" class="new-select bg-white" v-model="item.value" @change="changeValue($event,item,'status')">
                                        <option v-for="option in statusOptionsForOrg" :value="option.value" :key="option.value" :selected="item.value===option.value">{{option.label}}</option>
                                    </select>
                                    <select v-else class="new-select bg-white" v-model="statusValue" @change="changeValue($event,item,'status')">
                                        <option v-for="option in statusOptionsForOrg">{{option.label}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='dealStatus'">
                                    <select v-if="item.value!=''" class="new-select bg-white"  @change="changeValue($event,item,'status')">
                                        <option v-for="option in dealsStatusOptions" :value="option.value" :key="option.value" :selected="item.value===option.value">{{option.label}}</option>
                                    </select>
                                    <select v-else class="new-select bg-white" v-model="wordOne" @change="changeValue($event,item,'status')">
                                        <option v-for="option in dealsStatusOptions">{{option.label}}</option>
                                    </select>
                                </div>
                            <div v-else-if="item.type==='companyType'" class="col-md-5" >
                                <select v-if="item.value!=''" class="new-select bg-white" @change="changeValue($event,item,'isType')">
                                    <option v-for="option in isCandidateOptions" :value="option.value" :key="option.value" :selected="item.value===option.value">{{option.label}}</option>
                                </select>
                                <select v-else class="new-select bg-white" v-model="isCandidate" @change="changeValue($event,item,'isType')">
                                    <option v-for="option in isCandidateOptions">{{option.label}}</option>
                                </select>
                            </div>
                            <div v-else-if="item.type==='contacts'" class="col-md-5">
                                <input type="text" v-model="wordContact" v-on:keyup="quickFilter($event,'one','contact')" class="new-input bg-white mb-3"/>
                                <ul class="new-dropdown border-0 p-0 autocomplete-results" v-show='quickItemsOne.length>0'>
                                    <li class="autocomplete-result" v-for='(result, i) in quickItemsOne' :key="i" @click="setResult(result,'contact','one',item)">{{result.n}} {{result.sn}}</li>
                                    <li class="autocomplete-result" v-if="quickItemsOne.length<1">{{$ml.get('NOT_FIND')}}!!</li>
                                </ul>
                            </div>
                            <div v-else-if="item.type==='list'" class="ml-1 mr-3">
                                <div class="d-flex ml-2" v-if="isUsersList&&(($can('can_see_other_users_deals')&&(pageIs=='deal'||pageIs=='opportunities'))||($can('can_see_other_users_activities')&&pageIs=='activity'))">
                                    <div class="last">
                                        <div class="btn-group">
                                            <button type="button" class="searchBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{selectListText}}
                                            <i class="fa fa-angle-down pull-right ml-2"></i>
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0">
                                                
                                                <div class="search"><input type="text" class="new-input" v-model="userSearch"></div>
                                                <ul class="new-dropdown border-radius-0 p-0">
                                                    <li class="p-0" v-if="pageIs=='activity'">
                                                        <label class="w-100 custom-checkbox" v-if="user['_id']!=undefined">
                                                            <input type="radio" name="filterUser" :value="user['_id']['$oid']" @change="changeUsers($event,$ml.get('MY_ACTIVITIES'),'assignTo',item)"> 
                                                            <span class="label-text f-14">{{$ml.get("MY_ACTIVITIES")}}</span>
                                                        </label>
                                                    </li>
                                                    <li class="p-0" v-if="pageIs=='activity'">
                                                        <label class="w-100 custom-checkbox" v-if="user['_id']!=undefined">
                                                            <input type="radio" name="filterUser" :value="user['_id']['$oid']" @change="changeUsers($event,$ml.get('ACTIVTY_I_ASSIGNED'),'',item)"> 
                                                            <span class="label-text f-14">{{$ml.get("ACTIVTY_I_ASSIGNED")}}</span>
                                                        </label>
                                                    </li>
                                                    <li class="p-0">
                                                        <label class="w-100 custom-checkbox">
                                                            <input type="radio" name="filterUser" value="all" checked @change="changeUsers($event,$ml.get('ALL_USERS'),'',item)"> 
                                                            <span class="label-text f-14">{{$ml.get('ALL_USERS')}}</span>
                                                        </label>
                                                    </li>
                                                    <li v-if="usersForFilter.length==0">{{$ml.get('NO_USER_FOUND')}}</li>
                                                    <li class="p-0" v-for="user in activeUsersForFilter" :key="user._id && user._id.$oid">
                                                        <label class="w-100 custom-checkbox">
                                                            <input type="radio" name="filterUser" @change="changeUsers($event,user.name+' '+user.surName,'',item)" :value="user['_id']['$oid']"> 
                                                            <span class="label-text f-14">{{user.name}} {{user.surName}}</span>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                            <div v-else-if="item.type==='customContact'" class="col-md-5">
                                <input type="text" v-model="wordCustomContact" v-on:keyup="quickFilter($event,'two','contact')" class="new-input"/>
                                <ul class="new-dropdown border-0 p-0 autocomplete-results" v-show='quickItemsTwo.length>0'>
                                    <li class="autocomplete-result" v-for='(result, i) in quickItemsTwo' :key="i" @click="setResult(result,'contact','two',item)">{{result.n}} {{result.sn}}</li>
                                    <li class="autocomplete-result" v-if="quickItemsTwo.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                                </ul>
                            </div>
                             <div v-else-if="item.type==='singleChoose'" class="col-md-5">
                                <template v-for="(i, index) in customFields" :key="index">
                                <select v-model="item.value" v-if="i.field_type===6 && item.field_type===i.field_type && item.title==i._id.$oid" @change="changeValue($event,item,'customField')" class="new-select bg-white">
                                    <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" v-for="(o, optIndex) in i.options" :key="optIndex" :value="o.id">{{o.label}}</option>
                                </select>
                                </template>
                            </div>
                            <div v-else-if="item.type==='customOrganization'" class="col-md-5">
                                <input type="text" v-model="wordCustomOrganization" v-on:keyup="quickFilter($event,'two','organization')" class="new-input"/>
                                <ul class="new-dropdown border-0 p-0 autocomplete-results" v-show='quickItemsTwo.length>0'>
                                    <li class="autocomplete-result" v-for='(result, i) in quickItemsTwo' :key="i" @click="setResult(result,'organization','two',item)">{{result.name}}</li>
                                    <li class="autocomplete-result" v-if="quickItemsTwo.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                                </ul>
                            </div>
                            <div v-else-if="item.type==='customUser'" class="col-md-5 ">
                                <div class="last">
                                    <div class="btn-group">
                                        <button type="button" class="searchBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{selectListTextTwo}}
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right dropMenu search-multichange multiChoose p-0">
                                            <input type="text" v-model="wordTwo" class="new-input"/>
                                            <ul class="new-dropdown border-radius-0 p-0">
                                                <li class="p-0" v-for="user in usersForFilter">
                                                    <label class="w-100 custom-checkbox">
                                                        <input type="radio" name="filterUser" @change="changeUsers($event,user.name+' '+user.surName,'',item)" :value="user['_id']['$oid']"> 
                                                        <span class="label-text f-14">{{user.name}} {{user.surName}}</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.type==='multiChoose'" class="col-md-5">
                                <template v-for="(i, index) in customFields" :key="index">
                                <select v-model="item.value" v-if="i.field_type===7 && item.field_type===i.field_type && item.title==i._id.$oid" class="new-select bg-white" @change="changeValue($event,item,'customField')">
                                    <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                                    <option class="f-14 font-family-regular font-weight-normal" v-for="(o, optIndex) in i.options" :key="optIndex" :value="o.id">{{o.label}}</option>
                                </select>
                                </template>
                            </div>
                            <div class="col-md-5" v-else-if="item.type==='customDates'">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="in-filter" id="wordone" :label="$ml.get('SELECT_DATE')" v-model="wordDate" @input="changeValue($event,item,'isDateObj')" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-5" v-else>
                                <input type="text" v-model="item.value" class="new-input mb-3 bg-white inputValue" v-on:keyup="changeValue($event,item)">                               
                            </div>


                            <div class="col-md-1 px15 pb12 pl-1" v-if="updateItems.length >= 1">
                                <a class="btn btn-danger trash-icon" v-on:click="removeUpdateItem(index)">
                                    <i class="far fa-trash-alt text-white"></i>
                                </a>
                            </div>
                        </div>
                     

                    </div>


                    <div class="modal-footer">
                        <button type="button" class="btn bg-transparent" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn bg-new-primary" onclick="$('#updateFilterModal').modal('hide');" aria-label="Close" @click="saveAndUpdateFilter()">{{$ml.get('EDIT')}}</button>
                    </div>
                </div>
            </div>

            <div class="modal-dialog modal-md px-2" role="document" v-else>
                <div class="modal-content h-100" v-if="sameFilterTitle == false">
                    <div class="modal-header filterModalTitle py-3">
                        <h5 class="modal-title" id="createFilterModalLabel">
                            <i class="fas fa-exclamation-circle mr-1"></i>
                            {{$ml.get('SAVE_FILTER')}}
                        </h5>
                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body filter-modal" style="min-height: 20vh;">
                        <div v-if="filterType === 'deals'">
                            <label class="new-label font-family-bold">{{$ml.get('DEALS_NAME')}}*</label>
                            <input type="text" v-model="saveFieldName" class="new-input mb-2 w-100" />
                        </div>
                        <div v-if="filterType === 'activities'">
                            <label class="new-label font-family-bold">{{$ml.get('ACTIVITY_NAME')}}*</label>
                            <input type="text" v-model="saveFieldName" class="new-input mb-2 w-100" />
                        </div>
                        <div v-if="filterType === 'organizations'">
                            <label class="new-label font-family-bold">{{$ml.get('ORGANIZATION_NAME')}}*</label>
                            <input type="text" v-model="saveFieldName" class="new-input mb-2 w-100" />
                        </div>
                        <div v-if="filterType === 'contacts'">
                            <label class="new-label font-family-bold">{{$ml.get('CONTACT_NAME_V2')}}*</label>
                            <input type="text" v-model="saveFieldName" class="new-input mb-2 w-100" />
                        </div>
                        <div v-if="filterType === 'products'">
                            <label class="new-label font-family-bold">{{$ml.get('PRODUCT_NAME')}}*</label>
                            <input type="text" v-model="saveFieldName" class="new-input mb-2 w-100" />
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn bg-transparent" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn bg-new-primary" @click="saveAndApply()">{{$ml.get('SAVE_AND_APPLY')}}</button>
                        <!-- <button type="button" class="btn bg-new-primary" @click="saveAndApply()">{{$ml.get('SAVE_AND_APPLY')}}</button> -->
                    </div>
                </div>
                <div class="modal-content h-100" v-else-if="sameFilterTitle == true">
                    <div class="modal-header filterModalTitle py-3">
                        <h5 class="modal-title" id="createFilterModalLabel">
                            <i class="fas fa-exclamation-circle mr-1"></i>
                            Tekrarlanan Kayıt İsmi
                        </h5>
                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body filter-modal d-flex justify-content-center align-items-center" style="min-height: 10vh;">
                        <p><strong>{{ saveFieldName }}</strong> zaten var.Yeni kaydı nasıl oluşturmak istiyorsunuz?</p>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn bg-transparent" data-dismiss="modal" aria-label="Close">{{$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn button-outline bg-new-primary" @click="overwrite">Üzerine Yaz</button>
                        <button type="button" class="btn bg-new-primary" @click="saveAs">Farklı Kaydet</button>
                    </div>
                </div>
            </div>

        </div>


        <!-- Delete Saved Filter Modal -->
        <div class="modal fade h-100" id="deleteFilterID" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content px-2 py-3 bg-white">
                    <div class="modal-body text-center">
                        <i class="far fa-trash-alt fa-3x" style="background: #FF0000; color: #fff; padding: 1.5rem; border-radius: 50%;"></i>
                        <h2 class="my-3" style="color:#47495A;">Filtreyi Sil</h2>
                        <p style="color: #53565E; font-size: 16px;">
                            Filtre <strong>{{ filterNamePart }} </strong> silinecek.Onaylıyor musunuz?
                        </p>
                    </div>
                    <div class="modal-footer d-flex align-items-center justify-content-center">
                        <button type="button" class="btn bg-transparent btn-lg mr-2" style="font-weight: 500; font-size: 16px;" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn btn-lg" style="background: #FF0000; color: #fff; font-weight: 600; font-size: 16px;" data-dismiss="modal" @click="confirmFilterDeletion">{{$ml.get('YES')}}</button>
                    </div>
                </div>
            </div>
        </div>

        
    </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import {mapGetters} from 'vuex'

import _ from 'underscore'
export default {
    name: 'filterComponent',
    data () {
        return {
            filterType:"",
            fieldName:"",
            userSearch:"",    
            statusValue:'all',
            statusOptions : [
                {value: 'all', label: this.$ml.get('ALL')},
                {value: false, label: this.$ml.get('OPEN')},
                {value: true, label: this.$ml.get('COMPLETED')},
            ],
            statusOptionsForOrg : [
                {value: 'all', label: this.$ml.get('ALL')},
                {value: false, label: this.$ml.get('PASSIVE')},
                {value: true, label: this.$ml.get('ACTIVE')},
            ],
            isCandidate: "all",
            isCandidateOptions : [
                {value: 'all', label: this.$ml.get('ALL')},
                {value: true, label: this.$ml.get('LEAD')},
                {value: false, label: this.$ml.get('CUSTOMER')},
            ],
            dealsStatus:'all',
            dealsStatusOptions : [
                {value: 'all', label: this.$ml.get('ALL')},
                {value: 1, label: this.$ml.get('OPEN')},
                {value: 2, label: this.$ml.get('WON')},
                {value: 3, label: this.$ml.get('NOT_WON')}
            ],
            selectListText:this.$ml.get('ALL_USERS'),
            selectListTextTwo:this.$ml.get('SELECT'),
            selectListTextThree:this.$ml.get('SELECT'),

            defaultOne:"",
            filterDataOne:[],
            filterObjOne:{},
            wordOne:"",     
            quickItemsOne:[],
            quickItemName:"",

            defaultTwo:"",
            filterDataTwo:[],
            filterObjTwo:{},
            wordTwo:"",
            quickItemsTwo:[],

            UsersListObj:{},
            childObj:[],
            dateShortcuts:[
                { key: 'thisQuarter', label: this.$ml.get('THIS_QUARTER'), value: 'quarter' },//
                { key: 'thisMonth', label: this.$ml.get('THIS_MONTH'), value: 'month' },//
                { key: 'lastMonth', label: this.$ml.get('LAST_MONTH'), value: '-month' },//
                { key: 'thisWeek', label: this.$ml.get('THIS_WEEK'), value: 'isoWeek' },//
                { key: 'lastWeek', label: this.$ml.get('LAST_WEEK'), value: '-isoWeek' },//
                { key: 'thisYear', label: this.$ml.get('THIS_YEAR'), value: 'year' },//
                { key: 'lastYear', label: this.$ml.get('LAST_YEAR'), value: '-year' }//
            ],

            items: [],
            filterObjects:[],
            filterEnd:"",
            wordOrganization:'',
            wordDeal:'',
            wordProduct:'',
            wordDate:'',
            wordExpectedDate:'',
            wordClosedDate:'',
            wordDueDate:'',
            wordDoneDate:'',
            wordCreatedDate:'',
            wordContact:'',
            wordCustomOrganization:'',
            wordSingle:'',
            wordMulti:'',
            wordCustomContact:'',
            selectUser:'',
            isConcatenated:false,
            operators1:[
                {value:"contains",name:this.$ml.get('CONTAINS')},
                {value:"does_not_contain",name:this.$ml.get('DOES_NOT_CONTAIN')},
                {value:"equals",name:this.$ml.get('EQUAL')},
                {value:"does_not_equal",name:this.$ml.get('DOES_NOT_EQUAL')},
            ],
            operators2:[
                {value:"equals",name:this.$ml.get('EQUAL')},
                {value:"does_not_equal",name:this.$ml.get('DOES_NOT_EQUAL')},
            ],
            operators3:[
                {value:"equals",name:this.$ml.get('EQUAL')},
                {value:"does_not_equal",name:this.$ml.get('DOES_NOT_EQUAL')},
                {value:"less_than",name:this.$ml.get('LESS_THAN')},
                {value:"less_than_e",name:this.$ml.get('LESS_THAN_E')},
                {value:"greater_than",name:this.$ml.get('GREATER_THAN')},
                {value:"greater_than_e",name:this.$ml.get('GREATER_THAN_E')},
            ],
            operators4:[
                {value:"contains",name:this.$ml.get('CONTAINS')},
                {value:"does_not_contain",name:this.$ml.get('DOES_NOT_CONTAIN')},
                {value:"equals",name:this.$ml.get('EQUAL')},
                {value:"does_not_equal",name:this.$ml.get('DOES_NOT_EQUAL')},
                {value:"less_than",name:this.$ml.get('LESS_THAN')},
                {value:"less_than_e",name:this.$ml.get('LESS_THAN_E')},
                {value:"greater_than",name:this.$ml.get('GREATER_THAN')},
                {value:"greater_than_e",name:this.$ml.get('GREATER_THAN_E')},
            ],
            operators:[],
            saveAndApplyChecker: false,
            saveFieldName: "",
            filters: [],
            deleteFilterForm: null,
            filterNamePart: "",
            sameFilterTitle: false,
            sameFilterNameChecker: "",
            updateFilterName:"",
            isChangeFilterName:false,
            updateItems:[],
            listFilters:[],
            childFilterName:"",
            childFilterVal:"",
            isUpdateFilter:false,
            searchItem: ""
        }
    },
    props:["customFields","users","user","isUsersList","status","companyType","dealStatus","pageIs","isEmpty"],
    computed: {
        activeUsersForFilter(){
            return this.usersForFilter.filter(user => user && user.x)
        },
        usersForFilter(){
            // function to compare names
            function compare(a, b) {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
            }
            
            return (this.users || []).filter(user => {
                if (!user) return false
                const name = user.name || ''
                const surName = user.surName || ''
                return name.toLowerCase().includes(this.userSearch.toLowerCase()) || surName.toLowerCase().includes(this.userSearch.toLowerCase())
            }).sort(compare)
        },
        usersFilterSearch(){
            // function to compare names
            function compare(a, b) {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
            }
            function fullname(user){
                var name = ""
                var surname = ""
                if(user.name){
                    name = user.name
                }
                if(user.surName){
                    surname = user.surName
                }
                var fullName = name+" "+surname
                return fullName
            }
            
            return this.users.filter(user => {
                return fullname(user).toLowerCase().includes(this.wordTwo.toLowerCase())
            }).sort(compare)
        },
        usersSort() {
            return this.users.slice().sort(function(a, b){
                return (a.name > b.name) ? 1 : -1;
            });
        },
        ...mapState([
            'baseUrl',
            'cityList',
        ]),
        ...mapGetters(['localeLang'])
    },
    methods:{

        addCondition(){
            //add condition
            this.items.push({
                description:'',
                title: '',
                type:'',
                value:'',
                operator:'',
                field_type:'',
                options:''
            });
            if(this.isConcatenated==false){
                this.isConcatenated=true
                this.filterDataOne=this.filterDataOne.concat(this.customFields)         
            }
        }, 
        addUpdateCondition(){
            this.updateItems.push({
                description:'',
                title: '',
                type:'',
                value:'',
                operator:'',
                field_type:'',
                options:''
            });
        }, 
        removeItem(index){      
            this.items.splice(index,1)                       
        },
        removeUpdateItem(index){
            this.updateItems.splice(index,1)
        },
        applyFilter(){
            this.filterObjects = []
            this.childObj=this.items
            this.createFilter()
            if(this.filterObjects.length>0){
                this.$emit("filter",this.filterEnd)   
            }else{
                this.$emit("filter","")
            }
            
        },
        saveAndApply(){
            this.filterObjects = []
            this.createFilter()
            if((this.saveFieldName == "" || this.saveFieldName == null || this.saveFieldName == undefined)){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('WARNING'),
                    text: 'Lütfen bir filtre ismi giriniz'
                })

                return false
            }

            for(let i = 0; i < this.filters.length; i++){
                if(this.filters[i].name ===  this.saveFieldName){
                    // console.log('Aynısından var')
                    this.filters[i].name = this.sameFilterNameChecker
                    this.sameFilterTitle = true
                    break;
                }
            }

            if(this.sameFilterTitle == false){
                if(this.filterObjects.length>0){
                    this.$emit("filter",this.filterEnd)
                }else{
                    this.$emit("filter","")
                }
                
                let form = {}
    
                form.filter = {
                    ands: this.filterObjects,
                    name: this.saveFieldName,
                    searchMode: this.filterType
                }
    
                axios({
                    method:'POST',
                    url:'/saveFilters',
                    data: form,
                    baseURL: this.baseUrl,
                    withCredentials:true
                }).then((res)=>{
                        return res
                }).then((res)=>{
                    if(res.data.status.code==0){
                        this.getFilters()
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESS'),
                            text: res.data.status.desc 
                        })
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.data.status.desc 
                        })
                    }
                })
    
                $('#createFilterModal').modal('hide');

                this.searchItem = ""
            }

        },
        overwrite(){
            this.getFilters()
            $('#createFilterModal').modal('hide');
        },
        saveAs(){
            this.sameFilterTitle = false
            this.saveFieldName = ''
        },
        changeFilterName(){
            // this.filters[this.filterIndex].name=this.updateFilterName
            this.isChangeFilterName=false  
        },
        clearFilter(){
            this.isUpdateFilter=false
            this.childObj=[]
            this.updateItems=[]
            this.filterObjects=[]
            this.items = []
            
            this.$emit("filter","")
           
        },
        clearWords(){
            this.wordOne='',
            this.wordTwo='',
            this.wordOrganization='',
            this.wordDeal='',
            this.wordProduct='',
            this.wordDate='',
            this.wordExpectedDate='',
            this.wordClosedDate='',
            this.wordDueDate='',
            this.wordDoneDate='',
            this.wordCreatedDate='',
            this.wordContact='',
            this.wordCustomOrganization='',
            this.wordSingle='',
            this.wordMulti='',
            this.wordCustomContact='',
            this.selectUser='',
            this.selectListText=this.$ml.get('ALL_USERS'),
            this.selectListTextTwo=this.$ml.get('SELECT'),
            this.selectListTextThree=this.$ml.get('SELECT'),
            this.userSearch='',
            this.statusValue='all',
            this.isCandidate='all'
        },
        createFilter(){
            
            if(this.$route.path==="/opportunities"){
               let obj = {}
                
               if(this.childFilterVal!='all' && this.childFilterName!='' ){
                obj.fieldName = this.childFilterName
                obj.operator = "equals"
                obj.filterType = this.filterType
                obj.value = parseInt(this.childFilterVal)
                this.filterObjects.push(obj)
               }
               if(this.childFilterVal=='all'){
                
                   
                    this.childObj.forEach(item =>{
                        let obj = {}

                        obj.fieldName=item.title
                        obj.operator=item.operator
                        obj.filterType=this.filterType

                        if(item.title==='rate'){
                            obj.value=parseInt(item.value)
                            this.filterObjects.push(obj)
                        }
                        else if(item.title==='status'){
                            if(this.filterObjects.length<2 && item.value==='all'){
                                this.filterObjects=[]
                            }
                            else{
                                obj.value=item.value
                                this.filterObjects.push(obj)
                            }
                            
                        }
                        else if(item.title==='value'){
                            obj.value=Number(item.value)
                            this.filterObjects.push(obj)
                        }
                        else{
                            obj.value=item.value
                            this.filterObjects.push(obj)
                        }
                        
                    })
               }
                
            }   
            this.items.forEach(item =>{
                let obj = {}

                obj.fieldName=item.title
                obj.operator=item.operator
                obj.filterType=this.filterType

                if(item.title==='rate'){
                    obj.value=parseInt(item.value)
                    this.filterObjects.push(obj)
                }
                else if(item.title==='status'){
                    if(this.filterObjects.length<2 && item.value==='all'){
                        this.filterObjects=[]
                    }
                    else{
                        obj.value=item.value
                        this.filterObjects.push(obj)
                    }
                    
                }
                else if(item.title==='done'){
                    if(item.value===''){
                    }
                    else{
                        obj.value=item.value
                        this.filterObjects.push(obj)
                    }
                    
                }
                else if(item.title==='value'){
                    obj.value=Number(item.value)
                    this.filterObjects.push(obj)
                }
                else{
                    obj.value=item.value
                    this.filterObjects.push(obj)
                }
                
            })
            
            this.filterEnd={
                "searchMode":this.filterType,
                "name":"default",
                "ands":this.filterObjects
            }

        },
        createFilterSection(){
            
            this.saveAndApplyChecker = false
            this.saveFieldName = ''
            this.sameFilterTitle = false
            this.clearWords()
        },
        proceedTosaveAndApply(){
            this.saveAndApplyChecker = true
        },
        getFilters(){
            let form = {}
            this.listFilters =[]
            form.filter = {
                ands: this.filterObjects,
                name: this.saveFieldName,
                searchMode: this.filterType
                
            }
            
            axios({
                method:'POST',
                url:'/getFilters',
                data: form,
                baseURL: this.baseUrl,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                this.filters = res.data.content.filters[0]
                
                for(let i=0; i<this.filters.length; i++){
                    if(this.filterType===this.filters[i].searchMode){
                       this.listFilters.push(this.filters[i])
                    }
                }

                this.filters=this.listFilters

                if(res.data.status.code==0){
                    // this.$notify({ 
                    //     group: 'foo',
                    //     type: 'success', 
                    //     title: this.$ml.get('SUCCESS'),
                    //     text: res.data.status.desc 
                    // })
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        },
        getFilter(index){
        
            let form = {}

            form = {
                filterId: this.filters[index]._id.$oid,
            }

            axios({
                method:'POST',
                url:'/getFilter',
                data: form,
                baseURL: this.baseUrl,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{

                this.filterEnd={
                    "searchMode":this.filterType,
                    "name":"default",
                    "ands":res.data.content.filter[0].ands
                }
                if(this.$route.path==="/opportunities"){
                    
                    this.updateFilter(index)
                    this.childObj=this.updateItems
                    this.updateCreateFilter()
                    this.isUpdateFilter=true
                }   

                this.$emit("filter",this.filterEnd)
                  this.$emit("updatedCalendar",this.filterEnd)
                if(res.data.status.code==0){
 
                    // this.$notify({ 
                    //     group: 'foo',
                    //     type: 'success', 
                    //     title: this.$ml.get('SUCCESS'),
                    //     text: res.data.status.desc 
                    // })
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })

            

        },
        deleteFilter(index){
            $('#deleteFilterID').modal("show");

            this.filterNamePart = this.filters[index].name
        
            let form = {}

            form = {
                filterId: this.filters[index]._id.$oid
            }

            this.deleteFilterForm = form
        },
        confirmFilterDeletion(){
            axios({
                method:'POST',
                url:'/deleteFilter',
                data: this.deleteFilterForm,
                baseURL: this.baseUrl,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                // console.log('************************* deleteFilter section*************************')
                if(res.data.status.code==0){
                    this.$emit("filter","")
                    this.getFilters()

                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESS'),
                        text: res.data.status.desc 
                    })
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        },


        updateFilter(index){
             
            this.filterIndex=index
            this.saveFieldName=this.filters[index].name
            let updateItem = this.filters[index].ands
            this.updateItems=[]



            for(let i=0; i<updateItem.length; i++){

                let fieldNameValue = updateItem[i].fieldName
                let customFieldId,id 

                let item = {
                    description:'',
                    title:fieldNameValue,
                    type:'',
                    value:updateItem[i].value,
                    operator:updateItem[i].operator,
                    field_type:'',
                    options:''
                }

                for(let j=0; j<this.customFields.length; j++){
                    if(fieldNameValue===this.customFields[j]._id.$oid){
                        customFieldId = this.customFields[j]._id.$oid
                        id = this.customFields[j].field_type
                    }
                }

                if(fieldNameValue!=undefined){
                    if(fieldNameValue==='name' || fieldNameValue==='title' || fieldNameValue==='n'){
                        item.type='name'
                        item.options='name'
                    }
                    else if(fieldNameValue==='addDate'|| fieldNameValue==='expectedDate' || fieldNameValue==='doneDate' || fieldNameValue==='dueDate' || fieldNameValue==='createdAt' || fieldNameValue==='closedDate'){
                        if(fieldNameValue==='expectedDate'){
                            item.type='expectedDate'
                        }
                        else if(fieldNameValue==='doneDate'){
                            item.type='doneDate'
                        }
                        else if(fieldNameValue==='dueDate'){
                            item.type='dueDate'
                        }
                        else if(fieldNameValue==='createdAt'){
                            item.type='createdDate'
                        }
                        else if(fieldNameValue==='closedDate'){
                            item.type='closedDate'
                        }
                        else{
                        item.type='date' 
                        }
                        
                        item.options='date'
                    }
                    else if(fieldNameValue==='source'){
                        item.type='source'
                        item.options='source'  
                    }
                    else if(fieldNameValue==='rate'){
                        item.type='rate'
                        item.options='rate'   
                    }
                    else if(fieldNameValue==='value'){
                        item.type='value'
                        item.options='value'
                    }
                    else if(fieldNameValue==='currency'){
                        item.type='currency'
                        item.options='currency'
                    }
                    else if(fieldNameValue==='productList'){
                        item.type='product'
                        item.options='product'
                        
                    }
                    else if(fieldNameValue==='orgId' || fieldNameValue==='organization'){
                        item.type='organization'
                        item.options='organization'
                        this.getOrganization(item.value)
                        this.operators=[
                            {value:"equals",name:this.$ml.get('EQUAL')},
                        ]           
                    }
                    else if(fieldNameValue==='dealId'){
                        item.type='deal'
                        item.options='status'
                    }
                    else if(fieldNameValue==='activityStatus' || fieldNameValue==='companyStatus' || fieldNameValue==='done'){
                        item.type='status'
                        item.options='status'
                        if(fieldNameValue==='activityStatus'||fieldNameValue==='done'){
                            item.title='activityStatus'
                        }
                       
                    }
                    else if(fieldNameValue==='status'){
                        item.type='dealStatus'
                        item.options='status'
                        if(this.$route.path==="/organizations"){
                            item.type='status'
                            item.title='companyStatus'
                        }
                    }
                    else if(fieldNameValue==='isCandidate'){

                        item.type='companyType'
                        item.options='status'
                        item.title='companyType'
                    }
                    else if(fieldNameValue==='contacts' || fieldNameValue==='contactId'){
                        item.type='contacts'
                        this.getContact(item.value)
                        this.operators=[
                            {value:"equals",name:this.$ml.get('EQUAL')},
                        ]
                    }
                    else if(fieldNameValue==='assignor' || fieldNameValue==='assignedTo' || fieldNameValue==='owner'){
                        
                        if(fieldNameValue==='assignor'){
                            item.type='assignor'
                        }
                        else if(fieldNameValue==='assignedTo'){
                            item.type='assignedTo'
                        }
                        else if(fieldNameValue==='owner'){
                            item.type='owner'
                            item.title='list'
                        }
                        this.operators=[
                            {value:"equals",name:this.$ml.get('EQUAL')},
                        ]

                        for(let i=0; i<this.usersForFilter.length; i++){
                            
                            if(item.value===this.usersForFilter[i]._id.$oid){
                            
                                let name,surName

                                name=this.usersForFilter[i].name
                                surName=this.usersForFilter[i].surName
                                
                                if(item.type==='assignor'||item.type==='owner'){
                                    this.selectListTextTwo=name + " " + surName
                                }
                                else if(item.type==='assignedTo'){
                                    this.selectListTextThree=name + " " + surName
                                }
                                else{
                                    this.selectListText=name + " " + surName
                                }
                            }
                        }
                    }
                    else if(fieldNameValue==='list'){
                        
                        item.type='list'
                        item.options='list'
                    }
                    else if(customFieldId===fieldNameValue){ 
                       
                        if(id===9){
                            item.type='customContact'
                            item.field_type=9
                            item.options='customContact'
                            this.getContact(item.value,'isCustomField')
                        }
                        else if(id===6){
                            item.type='singleChoose'
                            item.field_type=6
                            item.options='singleChoose'
                        }
                        else if(id===8){
                            item.type='customOrganization'
                            item.field_type=8
                            item.options='customOrganization'  
                        }
                        else if(id===4){
                            item.type='customUser'
                            item.field_type=4
                            item.options='customUser'
                        }
                        else if(id===7){
                            item.type='multiChoose'
                            item.field_type=7
                            item.options='multiChoose'
                            
                        }
                        else if(id===3){
                            item.type='customDates'
                            item.options='customDates'
                        }
                        else if(id===5||id===2){
                            item.options='customCurrency'
                        }
                        else{
                            item.type='text'
                            item.options='text'
                        }
                    }
                    else{
                    item.type='text'
                    item.options='text'
                    }
                    
                }
                else{
                    
                }       
                this.updateItems.push(item)
            }    
        },
        updateCreateFilter(){
          

            if(this.$route.path==="/opportunities"){
               let obj = {}
                
               if(this.childFilterVal!='all' && this.childFilterName!='' ){
                obj.fieldName = this.childFilterName
                obj.operator = "equals"
                obj.filterType = this.filterType
                obj.value = parseInt(this.childFilterVal)
                this.filterObjects.push(obj)
               }
               if(this.childFilterVal=='all'){
                   
                    this.childObj.forEach(item =>{
                        let obj = {}

                        obj.fieldName=item.title
                        obj.operator=item.operator
                        obj.filterType=this.filterType

                        if(item.title==='rate'){
                            obj.value=parseInt(item.value)
                            this.filterObjects.push(obj)
                        }
                        else if(item.title==='status'){
                            if(this.filterObjects.length<2 && item.value==='all'){
                                this.filterObjects=[]
                            }
                            else{
                                obj.value=item.value
                                this.filterObjects.push(obj)
                            }
                            
                        }
                        else if(item.title==='value'){
                            obj.value=Number(item.value)
                            this.filterObjects.push(obj)
                        }
                        else{
                            obj.value=item.value
                            this.filterObjects.push(obj)
                        }
                        
                    })
               }
                
            }   

            this.updateItems.forEach(item =>{
                let obj = {}

                obj.fieldName=item.title
                obj.operator=item.operator
                obj.filterType=this.filterType

                if(item.title==='rate'){
                    obj.value=parseInt(item.value)
                    this.filterObjects.push(obj)
                }
                else if(item.title==='status'){
                    if(this.filterObjects.length<2 && item.value==='all'){
                        this.filterObjects=[]
                    }
                    else{
                        obj.value=item.value
                        this.filterObjects.push(obj)
                    }
                    
                }
                else if(item.title==='value'){
                    obj.value=Number(item.value)
                    this.filterObjects.push(obj)
                }
                else{
                    obj.value=item.value
                    this.filterObjects.push(obj)
                }
                
            })

            this.filterEnd={
                "searchMode":this.filterType,
                "name":"default",
                "ands":this.filterObjects
            }


        },

        saveAndUpdateFilter(){
            this.filterObjects = []
            this.updateCreateFilter()
            

            if(this.filterObjects.length>0){
                this.$emit("filter",this.filterEnd)
                
            }else{
                this.$emit("filter","")
            }
            
            let form = {}

            form.filterId = this.filters[this.filterIndex]._id.$oid,
            form.filter = {
                ands: this.filterObjects,
                name: this.saveFieldName,
                searchMode: this.filterType
            }

            axios({
                method:'POST',
                url:'/updateFilter',
                data: form,
                baseURL: this.baseUrl,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.getFilters()

                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESS'),
                        text: res.data.status.desc 
                    })
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
            
        },


        changeOperator(event,item){
            // let index = event.target.selectedIndex
            // item.operator=this.operators[index-1].value
            let operator = event.target.value

            
            if(operator===this.$ml.get('CONTAINS')){
                item.operator='contains'
            }
            else if(operator===this.$ml.get('DOES_NOT_CONTAIN')){
                item.operator='does_not_contain'
            }
            else if(operator===this.$ml.get('EQUAL')){
                item.operator='equals'
            }
            else if(operator===this.$ml.get('DOES_NOT_EQUAL')){
                item.operator='does_not_equal'
            }
            else if(operator===this.$ml.get('LESS_THAN')){
                item.operator='less_than'
            }
            else if(operator===this.$ml.get('LESS_THAN_E')){
                item.operator='less_than_e'
            }
            else if(operator===this.$ml.get('GREATER_THAN')){
                item.operator='greater_than'
            }
            else if(operator===this.$ml.get('GREATER_THAN_E')){
                item.operator='greater_than_e'
            }
            else if(operator===this.$ml.get('BETWEEN')){
                item.operator='between'
            }

        },
        
        changeValue(event,item,type){
            
            if(type=="isDateObj"){
                if(event == null || event.start==null || event.end==null){
                    return false
                }
                item.value={
                    startDate:event.start+"T00:00:00.000Z",
                    endDate:event.end+"T23:59:00.000Z"
                }
            }
            else if(type=="isType"){

                var keyword = event.target.value
                item.title="isCandidate"

                if(keyword===this.$ml.get('LEAD')){
                item.value=true
                }
                else if(keyword===this.$ml.get('CUSTOMER')){
                    item.value=false
                }
                else{
                    item.value='all'
                }
            }
            else if(type=="status"){
                if(this.pageIs=="organization"){
                    var keyword = event.target.value
                    item.title="status"
                    if(keyword===this.$ml.get('ACTIVE')){
                        item.value=true 
                    }
                    else if(keyword===this.$ml.get('PASSIVE')){
                        item.value=false
                    }
                    else{
                        item.value='all'
                    }
                }
                else if(this.pageIs=="opportunities"){
                    var keyword = event.target.value
                    
                    if(keyword===this.$ml.get('OPEN')){
                        item.value=1 
                    }else if(keyword===this.$ml.get('WON')){
                        item.value=2
                    }
                    else if(keyword===this.$ml.get('NOT_WON')){
                        item.value=3
                    }else{
                        item.value='all'
                    } 
                }
                else{
                    var keyword = event.target.value
                    item.title="done" 
                    if(keyword===this.$ml.get('COMPLETED')){
                        item.value=true 
                    }else if(keyword===this.$ml.get('OPEN')){
                        item.value=false
                    }else{
                        item.value=''
                    }  
                }
            }
            else if(item.title==="value"){
               item.value=event.target.value
                
            }
            else if(type=="customField" || item.title==='currency'){
                item.value=parseInt(event.target.value)
                
            }

            else{
            item.value=event.target.value
            
            }
            
            
        },
        changeFieldName(event,item){
            let fieldNameValue    
            let index = event.target.options.selectedIndex

            if(this.$route.path==="/opportunities"){
                if(index<14){
                    fieldNameValue = this.filterDataOne[index-1].value
                }
            }
            else if(this.$route.path==="/activities"){
                if(index<12){
                    fieldNameValue = this.filterDataOne[index-1].value
                }
            }
            else if(this.$route.path==="/organizations"){
                if(index<17){
                    fieldNameValue = this.filterDataOne[index-1].value
                }
            }
            else if(this.$route.path==="/contacts"){
                if(index<14){
                    fieldNameValue = this.filterDataOne[index-1].value
                }
            }
            else if(this.$route.path==="/products"){
                if(index<6){
                    fieldNameValue = this.filterDataOne[index-1].value
                }
            }
            else{
                if(index<12){
                    fieldNameValue = this.filterDataOne[index-1].value
                }
            }
            
            if(fieldNameValue!=undefined || fieldNameValue!=null){
                if(fieldNameValue==='name' || fieldNameValue==='title' || fieldNameValue==='n'){
                    item.type='name'
                    item.options='name'
                }
                else if(fieldNameValue==='addDate'|| fieldNameValue==='expectedDate' || fieldNameValue==='doneDate' || fieldNameValue==='dueDate' || fieldNameValue==='createdAt' || fieldNameValue==='closedDate'){
                    if(fieldNameValue==='expectedDate'){
                        item.type='expectedDate'
                    }
                    else if(fieldNameValue==='doneDate'){
                        item.type='doneDate'
                    }
                    else if(fieldNameValue==='dueDate'){
                        item.type='dueDate'
                    }
                    else if(fieldNameValue==='createdAt'){
                        item.type='createdDate'
                    }
                    else if(fieldNameValue==='closedDate'){
                        item.type='closedDate'
                    }
                    else{
                       item.type='date' 
                    }
                    
                    item.options='date'
                }
                else if(fieldNameValue==='source'){
                    item.type='source'
                    item.options='source'  
                }
                else if(fieldNameValue==='rate'){
                    item.type='rate'
                    item.options='rate'   
                }
                else if(fieldNameValue==='value'){
                    item.type='value'
                    item.options='value'
                }
                else if(fieldNameValue==='currency'){
                    item.type='currency'
                    item.options='currency'
                }
                else if(fieldNameValue==='productList'){
                    item.type='product'
                    item.options='product'
                    
                }
                else if(fieldNameValue==='orgId' || fieldNameValue==='organization'){
                    item.type='organization'
                    item.options='organization'
                    this.operators=[
                        {value:"equals",name:this.$ml.get('EQUAL')},
                    ]           
                }
                else if(fieldNameValue==='dealId'){
                    item.type='deal'
                    item.options='status'
                }
                else if(fieldNameValue==='activityStatus' || fieldNameValue==='companyStatus'){
                    item.type='status'
                    item.options='status'  
                }
                else if(fieldNameValue==='status'){
                    item.type='dealStatus'
                    item.options='status'
                }
                else if(fieldNameValue==='companyType'){
                    item.type='companyType'
                    item.options='status'
                }
                else if(fieldNameValue==='contacts' || fieldNameValue==='contactId'){
                    item.type='contacts'
                    this.operators=[
                        {value:"equals",name:this.$ml.get('EQUAL')},
                    ]
                }
                else if(fieldNameValue==='assignor' || fieldNameValue==='assignedTo' || fieldNameValue==='owner'){
                    
                    if(fieldNameValue==='assignor'){
                        item.type='assignor'
                    }
                    else if(fieldNameValue==='assignedTo'){
                        item.type='assignedTo'
                    }
                    else if(fieldNameValue==='owner'){
                        item.type='owner'
                    }
                    this.operators=[
                        {value:"equals",name:this.$ml.get('EQUAL')},
                    ]
                }
                else if(fieldNameValue==='list'){
                    item.type='list'
                    item.options='list'
                }
                else{
                item.type='text'
                item.options='text'
                }

                item.title=fieldNameValue
            }
            else{

                let customFieldsItem

                if(this.$route.path==="/opportunities"){
                    customFieldsItem=this.customFields[index-14]
                }
                else if(this.$route.path==="/activities"){
                    customFieldsItem=this.customFields[index-12]
                }
                else if(this.$route.path==="/organizations"){
                    customFieldsItem=this.customFields[index-17]
                }
                else if(this.$route.path==="/contacts"){
                    customFieldsItem=this.customFields[index-14]                         
                }
                else if(this.$route.path==="/products"){
                    customFieldsItem=this.customFields[index-6]                
                }
                else{
                    customFieldsItem=this.customFields[index-12]
                }
               
                let id = customFieldsItem.field_type
    
                if(id===9){
                    item.type='customContact'
                    item.field_type=9
                    item.options='customContact'
                }
                else if(id===6){
                    item.type='singleChoose'
                    item.field_type=6
                    item.options='singleChoose'
                }
                else if(id===8){
                    item.type='customOrganization'
                    item.field_type=8
                    item.options='customOrganization'  
                }
                else if(id===4){
                    item.type='customUser'
                    item.field_type=4
                    item.options='customUser'
                }
                else if(id===7){
                    item.type='multiChoose'
                    item.field_type=7
                    item.options='multiChoose'
                }
                else if(id===3){
                    item.type='customDates'
                    item.options='customDates'
                }
                else if(id===5||id===2){
                    item.options='customCurrency'
                }
                else{
                    item.type='text'
                    item.options='text'
                }
                item.title=customFieldsItem._id.$oid
                
            }
            
        },

        getOrganization(id){
               
              axios({
                  method:'POST',
                  url:'/getOrganization',
                  baseURL: this.baseUrl,
                  data: {
                      organizationId:id,
                  },
                  withCredentials:true
              }).then((res)=>{
                  return res
              }).then((res)=>{
                  
                  if(res.data.status.code==0){
                    this.wordOrganization=res.data.content.organization.name
                       
                  }else{
                      this.$notify({ 
                          group: 'foo',
                          type: 'error', 
                          title: this.$ml.get('ERROR'),
                          text: res.data.status.desc 
                      })
                       
                  }
              })
        },
        getContact(id,type){
              
            axios({
                method:'POST',
                url:'/getContact',
                baseURL: this.baseUrl,
                data: {
                    contactId:id,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                
                if(res.data.status.code==0){
                    if(type=='isCustomField'){
                        
                        this.wordCustomContact=res.data.content.contact.n+ " " + res.data.content.contact.n
                    }
                    else{
                        this.wordContact=res.data.content.contact.n+ " " + res.data.content.contact.n
                    }
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                    
                }
            })
        },

        childFilter(val,name){
            this.childFilterName=name
            this.childFilterVal=val
            
            if(val!="all"){
                let obj = {}
                obj.fieldName = this.childFilterName
                obj.operator = "equals"
                obj.filterType = this.filterType
                obj.value = parseInt(this.childFilterVal)
                this.filterObjects.push(obj)
                if(this.isUpdateFilter==true){
                    this.updateCreateFilter()
                }
                else{
                    this.createFilter()
                }
                
                this.$emit("filter",this.filterEnd)    
            }else{
                this.filterObjects = []
                this.createFilter()
                if(this.filterObjects.length<1){
                    
                    this.$emit("filter","")
                }
                else{
                    this.$emit("filter",this.filterEnd) 
                }
            }
        },
        changeUsers:function(val,text,assignedTo,item){
            
            if(item.title==='assignor'){
                this.selectListTextTwo=text
            }
            else if(item.title==='assignedTo'){
                this.selectListTextThree=text
            }
            else{
                this.selectListText=text
            }
            this.selectUser=val.target.value
            
            if(this.pageIs=="activity"){
                
                item.title="assignor"
            }else{
                if(item.field_type===4){
                    item.title=item.title
                }
                else{
                    item.title="owner"
                }
                
            }
            if(assignedTo){
                // this.fieldName="assignedTo"
                item.title="assignedTo"
            }
            this.UsersListObj={}
            // if(this.selectUser!='all'){
            //     this.createFilter("equals",selectUser,"changeList")
            // }else{
            //     this.createFilter(this.operators,"","changeList")
            // }
            item.value=val.target.value
            
        },
      
     
        quickFilter(event,filterNu,quickName){

            this.quickItemName=quickName

            if(filterNu=="one"){
                this.quickItemsOne=[]
            }else{
                this.quickItemsTwo=[]
            }
            var url,keyWord=event.target.value

            if(keyWord==""){
                if(filterNu=="one"){
                    this.filterObjOne={}
                    this.createFilter(this.operators,"",filterNu)
                    this.quickItemsOne=[]
                }else{
                    this.filterObjTwo={}
                    this.createFilter(this.operators,"",filterNu)
                    this.quickItemsTwo=[]
                }
            }else{

                var dataObj={
                        search:keyWord
                }

                if(quickName=="organization"){
                    url='/quickFilterOrganization'
                }else if(quickName=="contact"){
                    url='/quickFilterContact'
                }else if(quickName=="product"){
                    url='/quickFilterProduct'
                }else{
                    url='/quickFilterDeal'
                    dataObj={
                        dealName:keyWord
                    }
                }

                axios({
                    method:'POST',
                    url:url,
                    baseURL: this.baseUrl,
                    data: dataObj,
                    withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                    if(!res.data.status){
                        this.$router.push('/logout')
                    }
                    if(res.data.status.code==0){
                        if(filterNu=="one"){
                            if(quickName=="organization"){
                                this.quickItemsOne=res.data.content.organizations
                            }else if(quickName=="product"){
                                this.quickItemsOne=res.data.content.products
                            }else if(quickName=="contact"){
                                this.quickItemsOne=res.data.content.contacts
                            }else{
                                this.quickItemsOne=res.data.content.deals
                            }
                        }
                        if(filterNu=="two"){
                            if(quickName=="organization"){
                                this.quickItemsTwo=res.data.content.organizations
                            }else if(quickName=="product"){
                                this.quickItemsTwo=res.data.content.products
                            }else if(quickName=="contact"){
                                this.quickItemsTwo=res.data.content.contacts
                            }else{
                                this.quickItemsTwo=res.data.content.deals
                            }
                        }
                    }
                })
            }
        },
        setResult(result,type,filterNu,item){
            
            if(filterNu=="one"){
                this.quickItemsOne=[]
            }else{
                this.quickItemsTwo=[]
            }

            var name,getId
            
            if(type==="contact"){
                name=result.n + " " + result.sn
            }else if(type=="deal"){
                name=result.title
            }else{
                name=result.name
            }
            
            if(filterNu=="one" && (item.title==="orgId" || item.title==="organization")){              
                this.wordOrganization=name 
            }else if(filterNu=="one" && item.title==="productList"){              
                this.wordProduct=name
            }else if(filterNu=="two" && item.title==="dealId"){
                this.wordDeal=name
            }else if(filterNu=="one" && (item.title==="contactId" || item.title==="contacts")){
                this.wordContact=name
            }
            else if(filterNu=="two" && item.field_type===8){
                this.wordCustomOrganization=name
            }
            else if(filterNu=="two" && item.field_type===9){
                this.wordCustomContact=name
            }
            else{
                this.wordTwo=name
            }

            getId=result._id.$oid
            item.value=getId
            

        },
        path:function(){
            if(this.$route.path==="/deals" || this.$route.path==="/opportunities" || this.$route.path==="/"){
                this.defaultOne="title"
                this.filterDataOne=[
                    {value:"title",name:this.$ml.get('OPPORTUNITY_NAME')},
                    {value:"orgId",name:this.$ml.get('COMPANY_NAME')},
                    {value:"productList",name:this.$ml.get('PRODUCT')},
                    {value:"contactId",name:this.$ml.get('CONTACT_NAME')},
                    {value:"list",name:this.$ml.get('HOLDER')},
                    {value:"value",name:this.$ml.get('VALUE')},
                    {value:"currency",name:this.$ml.get('CURRENCY')},
                ]
                this.defaultTwo="source"
                this.filterDataTwo=[
                    {value:"source",name:this.$ml.get('SOURCE')},
                    {value:"rate",name:this.$ml.get('DEGREE')},
                    {value:"expectedDate",name:this.$ml.get('ESTIMATED_CLOSING')},
                    {value:"addDate",name:this.$ml.get('CREATION_DATE')},
                ]
                if(this.$route.path==="/opportunities"){
                    this.filterDataTwo.push(
                        {value:"closedDate",name:this.$ml.get('CLOSING_DATE')},
                        {value:"status",name:this.$ml.get('STATUS')}
                        )
                    }
                
                this.filterDataOne = this.filterDataOne.concat(this.filterDataTwo)
                this.filterType="deals"
            }else if(this.$route.path==="/organizations"){
                this.defaultOne="name"
                this.filterDataOne=[
                    {value:"name",name:this.$ml.get('COMPANY_NAME')},
                    {value:"companyType",name:this.$ml.get('TYPE_COMPANY')},
                    {value:"companyStatus",name:this.$ml.get('COMPANY_STATUS')},
                    {value:"contacts",name:this.$ml.get('CONTACT_NAME')},
                ]
                this.defaultTwo="taxNo"
                this.filterDataTwo=[
                    {value:"createdAt",name:this.$ml.get('CREATION_DATE')},
                    {value:"phoneNumbers",name:this.$ml.get('PHONE')},
                    {value:"faxNumbers",name:this.$ml.get('FAX')},
                    {value:"webAddr",name:this.$ml.get('WEB_SITES')},
                    {value:"emailAddresses",name:this.$ml.get('E_MAILS')},
                    {value:"addr",name:this.$ml.get('ADDRESS')},
                    {value:"country",name:this.$ml.get('COUNTRY')},
                    {value:"city",name:this.$ml.get('CITY')},
                    {value:"town",name:this.$ml.get('DISTRICT')},
                    {value:"postalCode",name:this.$ml.get('POST_CODE')},
                    {value:"taxNo",name:this.$ml.get('TAX_NUMBER')},
                    {value:"taxOffice",name:this.$ml.get('TAX_ADMINISTRATION')}
                ]
                this.filterDataOne = this.filterDataOne.concat(this.filterDataTwo)
                this.filterType="organizations"
            }else if(this.$route.path==="/contacts"){
                this.defaultOne="n"
                this.filterDataOne=[
                    {value:"n",name:this.$ml.get('NAME')},
                    {value:"sn",name:this.$ml.get('SURNAME')},
                    {value:"tck",name:this.$ml.get('TCK')},
                    {value:"email",name:this.$ml.get('EMAIL')},
                ]
                this.defaultTwo="addr"
                this.filterDataTwo=[
                    {value:"organization",name:this.$ml.get('RELATED_COMPANY')},
                    {value:"addr",name:this.$ml.get('ADDRESS')},
                    {value:"country",name:this.$ml.get('COUNTRY')},
                    {value:"city",name:this.$ml.get('CITY')},
                    {value:"town",name:this.$ml.get('DISTRICT')},
                    {value:"gsm",name:"Gsm"},
                    {value:"phone",name:this.$ml.get('LANDLINE')},
                    {value:"fax",name:this.$ml.get('FAX')},
                    {value:"createdAt",name:this.$ml.get('CREATION_DATE')},
                    //{value:"dob",name:this.$ml.get('DATE_OF_BIRTH')},
                    //{value:"wed_ann",name:this.$ml.get('WEDDING_ANNIVERSARY')}
                ]
                this.filterDataOne = this.filterDataOne.concat(this.filterDataTwo)
                this.filterType="contacts"
                
            }else if(this.$route.path==="/activities"){
                this.defaultOne="addDate"
                this.filterDataOne=[
                    {value:"activityStatus",name:this.$ml.get('ACTIVITY_STATUS')},
                    {value:"subject",name:this.$ml.get('SUBJECT')},
                    {value:"assignor",name:this.$ml.get('ASSIGNMENT')},
                    {value:"assignedTo",name:this.$ml.get('ASSIGNED')},
                    {value:"dealId",name:this.$ml.get('OPPORTUNITY_NAME')},
                    {value:"orgId",name:this.$ml.get('COMPANY_NAME')},
                    {value:"contactId",name:this.$ml.get('CONTACT_NAME')},
                    {value:"list",name:this.$ml.get('HOLDER')},
                ]
                this.defaultTwo="assignor"
                this.filterDataTwo=[
                    //{value:"subject",name:this.$ml.get('WEDDING_ANNIVERSARY')},
                    {value:"addDate",name:this.$ml.get('CREATION_DATE')},
                    {value:"doneDate",name:this.$ml.get('CLOSING_DATE')},
                    {value:"dueDate",name:this.$ml.get('PLANNING_HISTORY')}
                ]
                this.filterDataOne = this.filterDataOne.concat(this.filterDataTwo)
                this.filterType="activities"
            }else if(this.$route.path==="/products"){
                this.defaultOne="name"
                this.filterDataOne=[
                    {value:"name",name:this.$ml.get('PRODUCT_NAME')},
                    {value:"code",name:this.$ml.get('PRODUCT_CODE')}
                ]
                this.defaultTwo=""
                this.filterDataTwo=[
                    {value:"brand",name:this.$ml.get('BRAND')},
                    {value:"model",name:this.$ml.get('MODEL')},
                    {value:"description",name:this.$ml.get('DESCRIPTION')},
                    // {value:"addDate",name:this.$ml.get('CREATION_DATE')}
                ]
                this.filterDataOne = this.filterDataOne.concat(this.filterDataTwo)
                
                this.filterType="products"
            }
        },
    },
    created(){
        this.getFilters()
    },
    mounted: function () {
        this.path()
        if(this.pageIs=="activity"){
            this.statusValue=false
        }
    },
    watch: {
        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.autocomplete {
    position: relative;
    width: 130px;
}
    
.autocomplete-results {
    padding: 0;
    margin: 0;
    border-radius: 0;
    max-height: 130px;
    overflow: auto;
    border: 1px solid #3767a080;
    position: absolute;
    z-index: 9999;
    width: 100%;
    background-color: white;
}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 8px 15px;
    cursor: pointer;
}

.autocomplete-result:hover {
    background-color: #27aae1;
    color: white;
}

.multiChoose input[type="checkbox"], input[type="radio"]{
	position: absolute;
	right: 9000px;
}

.multiChoose label{
	cursor: pointer;
    color: #666;
    font-size: 13px;
}

@keyframes effect{
	0%{transform: scale(0);}
	25%{transform: scale(1.3);}
	75%{transform: scale(1.4);}
	100%{transform: scale(1);}
}
/*Radio box*/

.multiChoose input[type="radio"] + .label-text:before{
	content: "\f10c";
	font-family: "FontAwesome";
	speak: none;
	font-style: normal;
	font-weight: normal;
	font-variant: normal;
	text-transform: none;
	line-height: 1;
	-webkit-font-smoothing:antialiased;
	width: 1em;
	display: inline-block;
	margin-right: 5px;
}

.multiChoose input[type="radio"]:checked + .label-text:before{
	content: "\f192";
	color: #66D0FF!important;
	animation: effect 250ms ease-in;
}

.multiChoose input[type="radio"]:disabled + .label-text{
	color: #aaa;
}

.multiChoose input[type="radio"]:disabled + .label-text:before{
	content: "\f111";
	color: #ccc;
}

.updateAndDeleteSection{
    display: none;
}

.dropdown-item:hover .updateAndDeleteSection{
    display: block;
}

.filterInputs{
    background-color: #F7FAFD;
}
.filterInputs>div>i{
    content: "\f002";
    font-family: "FontAwesome";
    position: absolute;
    right: 14px;
    top: 12px;
}
.mw-150{
    max-width: 150px;
}

.filtreAndTableSetting{
    flex-wrap: inherit;
    align-items: flex-end;
}

.filterArea {
    flex-wrap: wrap;
    justify-content: flex-end;
}

.filterArea>div {
    height: 39px;
}
.clearBtn{
    background: white;
}
.clearBtn:hover{
    color: white;
}
.filterBtn{
    transform: scale(0.95);
}
.filterBtn:hover{
    background: rgb(28, 107, 255);
}

.filterModalTitle{
    background-color: #D7E3F4;
}

.button-outline{
    background-color: transparent;
    border: 1px solid #3C89D8;
    color: #3C89D8;
}
.trash-icon{
    height: 44px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.searchBtn{
    width: 301px;
    height: 43px;
    border: 1px solid #dedfe1;
    background: #fff;
    text-align: left;
    padding-left: 10px;
    outline: none;
    cursor: pointer;
    border-radius: 4px;
}
.searchBtn:focus{
    border: 1px solid #2296ee;
}
.filterName{
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
}
.filterNameInput{
    border: 1px solid rgb(216, 216, 216);
    border-radius: 4px;
    width: 320px;
    height: 36px;
    padding-left: 10px;
    font-size: 15px;
}
.filterNameInput:focus{
    border: 1px solid #36a8ff;
}
.filterName{
    position: relative;
}
.fa-check{
    position: absolute;
    left: 36%;
    top: 20%;
}
.searchBorder{
    border: 1px solid #ddd;
}

@media (max-width: 1200px) {
    .filterArea>div {margin-bottom: 10px;}
}
@media(max-width: 720px){
    .filterBtn{
        font-size: 13.5px;
        padding: 1px;
    }
    #filter{
        background-color: #f2f2f2 !important;
    }
}
@media(max-width: 576px){
    .px15{
        padding-left: 15px !important;
        padding-right: 15px !important;
    }
    .pb12{
        padding-bottom: 12px !important;
    }
}

</style>
